import { render, staticRenderFns } from "./PerformanceVideo.vue?vue&type=template&id=9b19ddf6"
import script from "./PerformanceVideo.vue?vue&type=script&lang=js"
export * from "./PerformanceVideo.vue?vue&type=script&lang=js"
import style0 from "./PerformanceVideo.vue?vue&type=style&index=0&id=9b19ddf6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports